import { Button, Box, Typography, useTheme } from "@mui/material";
import BrandSelector from "~components/atoms/BrandSelector";
import type { IProps } from "./interfaces";
import { getStyles } from "./styles";

const Headline = ({
  id,
  title,
  description,
  primaryButton,
  secondaryButton,
  hasDropdown,
}: IProps) => {
  const theme: any = useTheme();
  const { styles } = getStyles(theme, !!secondaryButton, false);

  return (
    <Box id={id}>
      <Box sx={styles.actions}>
        <Box display="flex" alignItems="center">
          <Typography variant="h1" sx={styles.title}>
            {title}
          </Typography>

          {hasDropdown && (
            <Box sx={{ marginLeft: "36px" }}>
              <BrandSelector showPrefix={true} />
            </Box>
          )}
        </Box>
        <Box sx={styles.buttons}>
          {primaryButton && (
            <Button
              disableFocusRipple
              disableRipple
              sx={styles.button.onDelete}
              onClick={primaryButton?.onAction}
              endIcon={primaryButton?.icon}
            >
              {primaryButton.text}
            </Button>
          )}

          {secondaryButton && (
            <Button
              disableFocusRipple
              disableRipple
              sx={styles.button.onPublish}
              onClick={secondaryButton.onAction}
              endIcon={secondaryButton.icon}
            >
              {secondaryButton.text}
            </Button>
          )}
        </Box>
      </Box>

      <Typography variant="subtitle1" sx={styles.description}>
        {description}
      </Typography>
    </Box>
  );
};

export default Headline;
